import React from 'react';
import { DatoCmsTwoColumnRichText } from '../../../schema/datocms/blocks';
import HtmlStringComponent from '../../html-string/html-string-component';

const TwoColumnRichTextComponent = (
    { leftTextHtml, rightTextHtml, wrapLeftColumn, wrapRightColumn
    }: DatoCmsTwoColumnRichText
): React.ReactElement => {
    const backgroundClass: string = 'bg-light-gray border border-primary rounded px-2';

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 space-x-0 lg:space-x-8">
            { leftTextHtml && <HtmlStringComponent className={`${wrapLeftColumn ? backgroundClass : ''} py-8`} htmlString={leftTextHtml} />}
            { rightTextHtml && <HtmlStringComponent className={`${wrapRightColumn ? backgroundClass : ''} py-8`} htmlString={rightTextHtml} />}
        </div>
    );
};

export default TwoColumnRichTextComponent;
